import { useGetServiceQuery } from '../api';
import { serviceDetailsTransformer } from '../helpers';
import { ServiceDetails } from '../types';

export function useServiceDetails({ id }: { id: string }): ServiceDetails | null {
  const { data: service } = useGetServiceQuery({ id });
  if (!service) return null;
  return serviceDetailsTransformer(service);
}
